import { ProjectGateway } from './project-gateway.interface';

export const initProjectAPI = (apiSlice: any, gateway: ProjectGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Project'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getProjectById: builder.query({
          query: gateway.getProjectById,
          providesTags: ['Project'],
        }),
        getProjectsByUser: builder.query({
          query: gateway.getProjectsByUser,
          providesTags: ['Project'],
        }),
        getProjectByCustomer: builder.query({
          query: gateway.getProjectByCustomer,
          providesTags: ['Project'],
        }),
        getProjectByToken: builder.query({
          query: gateway.getProjectByToken,
          providesTags: ['Project'],
        }),
        getOpportunityById: builder.query({
          query: gateway.getOpportunityById,
          providesTags: ['Project'],
        }),
        getMondayProjectById: builder.query({
          query: gateway.getMondayProjectById,
          providesTags: ['Project'],
        }),
        getPlanningByProjectId: builder.query({
          query: gateway.getPlanningByProjectId,
          providesTags: ['Project'],
        }),
        getTechnicalVisitByProjectId: builder.query({
          query: gateway.getTechnicalVisitByProjectId,
          providesTags: ['Project'],
        }),
        getTransportByProjectId: builder.query({
          query: gateway.getTransportByProjectId,
          providesTags: ['Project'],
        }),
        getProductionByProjectId: builder.query({
          query: gateway.getProductionByProjectId,
          providesTags: ['Project'],
        }),
        getSAVByProjectId: builder.query({
          query: gateway.getSAVByProjectId,
          providesTags: ['Project'],
        }),
        getPluAnalyseByProjectId: builder.query({
          query: gateway.getPluAnalyseByProjectId,
          providesTags: ['PluAnalyse'],
        }),
        patchPluAnalyse: builder.mutation({
          query: gateway.patchPluAnalyse,
          invalidatesTags: ['PluAnalyse'],
        }),
        getIncidentByProjectId: builder.query({
          query: gateway.getIncidentByProjectId,
        }),
        getMondayLineByBoardIdAndItemId: builder.query({
          query: gateway.getMondayLineByBoardIdAndItemId,
        }),
        searchProject: builder.query({
          query: gateway.searchProject,
        }),
        getPluByProject: builder.query({
          query: gateway.getPluByProject,
          providesTags: ['Project'],
        }),
        getPaginatedProject: builder.query({
          query: gateway.getPaginatedProject,
          providesTags: ['Project'],
        }),
        getArchiveProjectByDateOf: builder.query({
          query: gateway.getArchiveProjectByDateOf,
        }),
        getArchiveProjectsCount: builder.query({
          query: gateway.getArchiveProjectsCount,
        }),
        getArchiveBdc: builder.query({
          query: gateway.getArchiveBdc,
          providesTags: ['Project'],
        }),
        getArchiveBdcCount: builder.query({
          query: gateway.getArchiveBdcCount,
        }),
        getSortedClient: builder.query({
          query: gateway.getSortedClient,
        }),
        triggerPostInMonday: builder.mutation({
          query: gateway.triggerPostInMonday,
          invalidatesTags: ['Project'],
        }),
        triggerPrefillKizeo: builder.mutation({
          query: gateway.triggerPrefillKizeo,
          invalidatesTags: ['Project'],
        }),
        triggerSyncSignWithOdoo: builder.mutation({
          query: gateway.triggerSyncSignWithOdoo,
          invalidatesTags: ['Project'],
        }),
        triggerProject10Payment: builder.mutation({
          query: gateway.triggerProject10Payment,
          invalidatesTags: ['Project'],
        }),
        triggerProjectFollowingInstructions: builder.mutation({
          query: gateway.triggerProjectFollowingInstructions,
          invalidatesTags: ['Project', 'Task'],
        }),
        triggerProject50Payment: builder.mutation({
          query: gateway.triggerProject50Payment,
          invalidatesTags: ['Project'],
        }),
        syncWithOdoo: builder.mutation({
          query: gateway.syncWithOdoo,
          invalidatesTags: ['Project'],
        }),
        syncWithMonday: builder.mutation({
          query: gateway.syncWithMonday,
          invalidatesTags: ['Project'],
        }),
        postCustomerR1New: builder.mutation({
          query: gateway.postCustomerR1New,
          invalidatesTags: ['Task'],
        }),
        postLostRestart: builder.mutation({
          query: gateway.postLostRestart,
          invalidatesTags: ['Project'],
        }),
        patchProject: builder.mutation({
          query: gateway.patchProject,
          invalidatesTags: ['Project'],
        }),
        patchNoShow: builder.mutation({
          query: gateway.patchNoShow,
          invalidatesTags: ['Project'],
        }),
        patchReport: builder.mutation({
          query: gateway.patchReport,
          invalidatesTags: ['Project'],
        }),
        patchNext: builder.mutation({
          query: gateway.patchNext,
          invalidatesTags: ['Project'],
        }),
        patchCancel: builder.mutation({
          query: gateway.patchCancel,
          invalidatesTags: ['Project'],
        }),
        patchDelete: builder.mutation({
          query: gateway.patchDelete,
          invalidatesTags: ['Project'],
        }),
        patchProjectConducteurTvx: builder.mutation({
          query: gateway.patchProjectConducteurTvx,
          invalidatesTags: ['Project', 'User'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface ProjectSliceType {
  useGetProjectByIdQuery: Function;
  useLazyGetProjectByIdQuery: Function;
  useGetProjectsByUserQuery: Function;
  useLazyGetProjectsByUserQuery: Function;
  useGetProjectByCustomerQuery: Function;
  useGetProjectByTokenQuery: Function;
  useLazyGetProjectByTokenQuery: Function;
  useGetOpportunityByIdQuery: Function;
  useGetMondayProjectByIdQuery: Function;
  useGetMondayLineByBoardIdAndItemIdQuery: Function;
  useLazyGetMondayLineByBoardIdAndItemIdQuery: Function;
  useSearchProjectQuery: Function;
  useLazySearchProjectQuery: Function;
  useGetPluByProjectQuery: Function;
  useGetPaginatedProjectQuery: Function;
  useLazyGetPaginatedProjectQuery: Function;
  useGetArchiveProjectByDateOfQuery: Function;
  useGetArchiveProjectsCountQuery: Function;
  useGetArchiveBdcQuery: Function;
  useLazyGetArchiveBdcQuery: Function;
  useGetArchiveBdcCountQuery: Function;
  useLazyGetArchiveBdcCountQuery: Function;
  useGetSortedClientQuery: Function;
  useLazyGetSortedClientQuery: Function;
  useTriggerPostInMondayMutation: Function;
  useTriggerPrefillKizeoMutation: Function;
  useTriggerSyncSignWithOdooMutation: Function;
  useTriggerProject10PaymentMutation: Function;
  useTriggerProjectFollowingInstructionsMutation: Function;
  useTriggerProject50PaymentMutation: Function;
  useSyncWithOdooMutation: Function;
  useSyncWithMondayMutation: Function;
  usePostCustomerR1NewMutation: Function;
  usePostLostRestartMutation: Function;
  usePatchProjectMutation: Function;
  usePatchNoShowMutation: Function;
  usePatchReportMutation: Function;
  usePatchNextMutation: Function;
  usePatchCancelMutation: Function;
  usePatchDeleteMutation: Function;
  useGetPlanningByProjectIdQuery: Function;
  useGetTechnicalVisitByProjectIdQuery: Function;
  useGetTransportByProjectIdQuery: Function;
  useGetIncidentByProjectIdQuery: Function;
  useGetProductionByProjectIdQuery: Function;
  useGetSAVByProjectIdQuery: Function;
  useGetPluAnalyseByProjectIdQuery: Function;
  usePatchPluAnalyseMutation: Function;
  usePatchProjectConducteurTvxMutation: Function;
}
